// extracted by mini-css-extract-plugin
module.exports = {"plans":"PlanList_plans__TSe1w","plans__paymentDetails":"PlanList_plans__paymentDetails__g98Tj"};